export const configConstants = [
  {
    type: "LLM Category",
    value: "llmCategory",
  },
  {
    type: "Errors Category",
    value: "errorsCategory",
  },
  {
    type: "Messages Category",
    value: "messagesCategory",
  },
  {
    type: "FAQ Category",
    value: "faqCategory",
  },
  {
    type: "Prompy Template",
    value: "promptTemplate",
  },
  {
    type: "Zenvoya App",
    value: "zenvoyaApp",
  },
];

export const LLM_CONSTANTS = [
  {
    type: "Anthropic",
    value: "anthropic",
  },
  {
    type: "OpenAI",
    value: "openai",
  },
];
